import { createAction } from 'redux-actions';

import {
  LOAD_PRIVACY_WORDING,
  LOAD_PRIVACY_WORDING_SUCCESS,
  LOAD_PRIVACY_WORDING_ERROR,
  LOAD_TERM_WORDING,
  LOAD_TERM_WORDING_SUCCESS,
  LOAD_TERM_WORDING_ERROR,
} from './type';

//Logout
export const loadPrivacyWordingAction = createAction(LOAD_PRIVACY_WORDING);
export const loadPrivacyWordingSuccessAction = createAction(
  LOAD_PRIVACY_WORDING_SUCCESS,
);
export const loadPrivacyWordingErrorAction = createAction(
  LOAD_PRIVACY_WORDING_ERROR,
);

//Reset password
export const loadTermWordingAction = createAction(LOAD_TERM_WORDING);
export const loadTermWordingSuccessAction = createAction(
  LOAD_TERM_WORDING_SUCCESS,
);
export const loadTermWordingErrorAction = createAction(LOAD_TERM_WORDING_ERROR);
